import { Equipment } from "./equipment.model";
import { Plant } from "./plant.model";
import { InsertionCycle } from "./insertion-cycle.model";
import { LineLocation } from "./line-location.model";

export class Line {
    public id: number;
    public name: string;
    public mesId: string;
    public locationId: string;
    public description: string;
    public plant: Plant;
    public plantId = -1;
    public equipment: Equipment[];
    public inUse: boolean;
    public isSPI: boolean;
    public insertionCycles: InsertionCycle[];
    public toolRequestsLimit: number;
    public lineLocations: LineLocation[];
    public contactEmailAddress?: string;
    public toolMaxTransportTime?: number;

    constructor(line: any = {}) {
        this.id = line.id || 0;
        this.name = line.name || "";
        this.description = line.description || "";
        this.inUse = line.inUse;
        this.mesId = line.mesId || "";
        this.locationId = line.locationId || "";
        this.lineLocations = line.lineLocations || "";
        this.isSPI = line.isSPI || false;
        this.toolRequestsLimit = line.toolRequestsLimit || 5;
        this.contactEmailAddress = line.contactEmailAddress || "";
        this.toolMaxTransportTime = line.toolMaxTransportTime || 0;
        this.mapEquipment(line.equipment);
        this.mapPlant(line.plant);
        this.mapInsetionCycle(line.insertionCycles);
    }

    mapPlant(plant = {}) {
        this.plant = new Plant(plant || {});
        this.plantId = this.plant.id;
    }

    mapEquipment(equipment = []) {
        this.equipment = equipment.map((eq) => new Equipment(eq));
    }

    mapInsetionCycle(insertionCycles = []) {
        this.insertionCycles = insertionCycles.map(
            (ic) => new InsertionCycle(ic)
        );
    }

    mapLineLocations(lineLocations = []) {
        this.lineLocations = lineLocations.map((loc) => new LineLocation(loc));
    }

    get type() {
        return "line";
    }
}
